import { render, staticRenderFns } from "./health-data-container.vue?vue&type=template&id=bed5a3c4&scoped=true&lang=pug"
import script from "./health-data-container.js?vue&type=script&lang=js&external"
export * from "./health-data-container.js?vue&type=script&lang=js&external"
import style0 from "./health-data-container.vue?vue&type=style&index=0&id=bed5a3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed5a3c4",
  null
  
)

export default component.exports